import {TextField, TextFieldProps} from '@material-ui/core';
import {InvalidGuid, ValidGuid} from 'BOSTools/models/Guid';
import React, {useState} from 'react';

export type GuidTextInputProps = TextFieldProps & {
  guid: ValidGuid | InvalidGuid;
};

const GuidLength = 36;

const GuidTextInput = ({id, label, onChange, guid}: GuidTextInputProps) => {
  const [touched, setTouched] = useState(false);

  return (
    <TextField
      id={id}
      fullWidth
      variant="outlined"
      label={label}
      value={guid.value}
      onChange={onChange}
      inputProps={{maxLength: GuidLength, minLength: GuidLength}}
      onBlur={() => setTouched(true)}
      required
      error={touched && guid instanceof InvalidGuid}
      helperText={touched && guid instanceof InvalidGuid && guid.validationError}
    />
  );
};

export default GuidTextInput;
